import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { supabase } from '../lib/supabase';

const VocabularyContext = createContext({});

export const useVocabulary = () => {
    const context = useContext(VocabularyContext);
    if (!context) {
        throw new Error('useVocabulary must be used within VocabularyProvider');
    }
    return context;
};

// Default vocabulary (fallback)
const defaultVocabulary = {
    item: 'Item',
    items: 'Items',
    client: 'Cliente',
    clients: 'Clienti',
    supplier: 'Fornitore',
    suppliers: 'Fornitori',
};

export const VocabularyProvider = ({ children }) => {
    const { organizationId } = useAuth();
    const [vocabulary, setVocabulary] = useState(defaultVocabulary);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (organizationId) {
            fetchVocabulary();
        } else {
            setVocabulary(defaultVocabulary);
            setLoading(false);
        }
    }, [organizationId]);

    const fetchVocabulary = async () => {
        try {
            const { data, error } = await supabase
                .from('organizations')
                .select('vocabulary')
                .eq('id', organizationId)
                .single();

            if (error) throw error;

            // Vocabulary is stored in dedicated vocabulary field
            if (data?.vocabulary) {
                setVocabulary({ ...defaultVocabulary, ...data.vocabulary });
            } else {
                // Fallback to default
                setVocabulary(defaultVocabulary);
            }
        } catch (error) {
            console.error('Error fetching vocabulary:', error);
            setVocabulary(defaultVocabulary);
        } finally {
            setLoading(false);
        }
    };

    // Translation function
    const t = (key, defaultValue) => {
        return vocabulary[key] || defaultValue || key;
    };

    const value = {
        vocabulary,
        t,
        loading,
    };

    return (
        <VocabularyContext.Provider value={value}>
            {children}
        </VocabularyContext.Provider>
    );
};
